/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Model_Deep_HintInputs */



/**
* | output |
* | --- |
* | "Uses Claude Opus for harder tasks. Uses credits about 2× faster." |
*
* @param {Assistant_Model_Deep_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_model_deep_hint = /** @type {((inputs?: Assistant_Model_Deep_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Model_Deep_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilise Claude Opus pour les tâches plus complexes. Consomme les crédits environ deux fois plus vite.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzt Claude Opus für schwierigere Aufgaben. Verbraucht Credits etwa doppelt so schnell.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Utilizza Claude Opus per i compiti più difficili. Consuma crediti circa due volte più velocemente.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Использует Claude Opus для более сложных задач. Расходует кредиты примерно в 2 раза быстрее.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Utiliza Claude Opus para las tareas más difíciles. Consume créditos aproximadamente el doble de rápido.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用 Claude Opus 处理更复杂的任务。消耗积分的速度大约快 2 倍。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("難易度の高いタスクにはクロード・オーパスを使用します。クレジットの消費速度は約2倍です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कठिन कार्यों के लिए क्लाउड ओपस का उपयोग करता है। क्रेडिट का उपयोग लगभग 2 गुना तेजी से करता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Usa Claude Opus para tarefas mais difíceis. Consome créditos aproximadamente 2 vezes mais rápido.")
	return /** @type {LocalizedString} */ ("Uses Claude Opus for harder tasks. Uses credits about 2× faster.")
});